









































































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions } from 'ag-grid-community'
import { Employee } from '@/model/companyStructure/Employee'
import BooleanCellRenderer from '@/components/cell-renderer/BooleanCellRenderer.vue'
import {
  CALENDAR_EVENT_ASSISTANT_GET_CALENDAR_EVENT_ITEM,
  CALENDAR_EVENT_ASSISTANT_GET_END_DATE,
  CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE,
  CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY,
  CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST, CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_SERIE,
  CALENDAR_EVENT_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST,
  CALENDAR_EVENT_ASSISTANT_GET_START_DATE,
  GET_SELECTED_UI_LANGUAGE
} from '@/store/getter-types'
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'
import {
  CALENDAR_EVENT_ASSISTANT_SET_IS_EDITING_SERIE,
  CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_SERIE,
  CALENDAR_EVENT_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST,
  CREATE_CALENDAR_EVENT
} from '@/store/action-types'
import {
  CalendarEventSerie,
  CreateCalendarEventSeriesResponse,
  KalenderArtVeranstaltungen, KalenderEventsCategorize
} from '@/types/service-response'
import { CreateCalendarEventSeriesRequest, PlanningAssistantPeriodicityPayload } from '@/types/payload'
import moment from 'moment'
import { PlannedEmployee } from '@/model/planning/PlannedEmployee'
import { PeriodicityPlannedCalendarEventEmployee } from '@/types'
import { CalendarEvent } from '@/model/planning/CalendarEvent'
import CalendarEventEditorEmployeeSelectorDialog
  from '@/components/planning/calendar-event/employee/CalendarEventEditorEmployeeSelectorDialog.vue'
import { CalendarEventEmployee } from '@/model/calendarEvent/CalendarEventEmployee'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  gridOptions: GridOptions
  selectedEmployeeList: Array<Employee>
  gridFrameworkComponents: Object
  showEmployeeSelector: boolean
  currentSelectedRowData: any
  overlayNoRowsTemplate: string
  selectedItem: PeriodicityPlannedCalendarEventEmployee | undefined
  loading: boolean
  panel: number[]
  isExpansionPanelReadonly: boolean
  periodicitySelectedRow: string | undefined
}

export default Vue.extend({
  name: 'CalendarEventEditorEmployeeSelect',

  components: {
    AgGridVue,
    CalendarEventEditorEmployeeSelectorDialog
  },

  props: {
    editCalendarEvent: Object as () => CalendarEvent | undefined,
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('planningPage.name').toString(), field: 'name' },
          { headerName: this.$t('planningPage.capacity').toString(), field: 'capacity' },
          {
            headerName: this.$t('planningPage.jumper').toString(),
            field: 'isFloater',
            cellRenderer: 'booleanRenderer'
          },
          { headerName: this.$t('planningPage.planningGroup').toString(), field: 'planningGroupName' },
        ],
      },

      selectedEmployeeList: [],

      gridFrameworkComponents: {
        booleanRenderer: BooleanCellRenderer
      },

      showEmployeeSelector: false,
      currentSelectedRowData: undefined,
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      selectedItem: undefined,
      loading: false,
      panel: [0],
      isExpansionPanelReadonly: false,
      periodicitySelectedRow: undefined,
    }
  },

  computed: {
    dateStart (): Date {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_START_DATE]
    },

    dateEnd (): Date {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_END_DATE]
    },

    plannedEmployeeList (): CalendarEventEmployee[] {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
    },

    periodicityPlannedEmployeeList (): PeriodicityPlannedCalendarEventEmployee[] {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
    },

    isRemoveButtonDisabled (): boolean {
      return !this.currentSelectedRowData
    },

    periodicity (): PlanningAssistantPeriodicityPayload {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY]
    },

    isEditingSerie (): boolean {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE]
    },

    serieData (): CalendarEventSerie[] | undefined {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_SERIE]
    },

    selectedLanguage (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },
  },

  methods: {
    formattedDate (date: string): string {
      return moment(date, 'DD.MM.YYYY').locale(this.selectedLanguage).format('DD.MM.YYYY - dddd')
    },

    floaterIconColor (employee: CalendarEventEmployee): string {
      return employee.isFloater ? 'green' : 'red'
    },

    floaterIcon (employee: CalendarEventEmployee): string {
      return employee.isFloater ? 'check' : 'clear'
    },

    onAddEmployeeButtonClick (item?: PeriodicityPlannedCalendarEventEmployee): void {
      this.isExpansionPanelReadonly = true
      this.showEmployeeSelector = true
      if (item && item.date) {
        this.selectedItem = item
        this.periodicitySelectedRow = _.findIndex(this.periodicityPlannedEmployeeList, { date: item.date }).toString()
      }
    },

    onRowClicked (params: any): void {
      this.currentSelectedRowData = params.node.data
    },

    onRemoveEmployeeButtonClick (): void {
      let plannedEmployeeList: CalendarEventEmployee[] = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
      this.plannedEmployeeList.splice(
        _.findIndex(this.plannedEmployeeList, { id: this.currentSelectedRowData.id }), 1)
      this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, plannedEmployeeList)
      this.currentSelectedRowData = undefined
    },

    onCloseEmployeeSelector (): void {
      this.loading = false
      this.isExpansionPanelReadonly = false
      this.showEmployeeSelector = false
      this.periodicitySelectedRow = undefined
    },

    onAddEmployeeListToSelection (employeeList: EmployeeAvailableForPlanning[]): void {
      if (!this.isEditingSerie) {
        const selectedEmployeeList: CalendarEventEmployee[] = employeeList
            .map((item: EmployeeAvailableForPlanning): CalendarEventEmployee => {
              return new CalendarEventEmployee(
                  item.id,
                  item.name,
                  item.capacity,
                  item.isFloater,
                  item.planingGroupName,
                  '',
                  this.dateStart,
                  this.dateEnd,
                  undefined
              )
            })

        const newEmployeeList: CalendarEventEmployee[] = ([] as CalendarEventEmployee[]).concat(this.plannedEmployeeList, selectedEmployeeList)

        this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, newEmployeeList)

        if (!this.periodicity.isUnique) {
          this.createCalendarEvent()
        } else {
          this.onCloseEmployeeSelector()
        }
      }
    },

    onPeriodicityRemoveEmployeeButtonClick (idx: number, employee: PlannedEmployee) {
      let localPlannedEmployeeList: PeriodicityPlannedCalendarEventEmployee[] = _.cloneDeep(this.periodicityPlannedEmployeeList)
      localPlannedEmployeeList[idx].employeeList.splice(
          _.findIndex(localPlannedEmployeeList[idx].employeeList, { id: employee.id }), 1)
      this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
    },

    async createCalendarEvent (): Promise<void> {
      try {
        const employeeList: Array<CalendarEventEmployee> = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
        const calendarEventItem: KalenderEventsCategorize = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_CALENDAR_EVENT_ITEM]

        const employeeIdList: number[] = employeeList.map((item: CalendarEventEmployee) => {
          return item.id!
        })

        const newPeriodicityCalendarEventPayload: CreateCalendarEventSeriesRequest = {
          Titel: calendarEventItem.text ? calendarEventItem.text : '',
          Beschreibung: '',
          Mitarbeiter: employeeIdList,
          EinmaligMitarbeiterBeschreibung: [],
          DatumStart: this.dateStart ? moment(this.dateStart).format('YYYY-MM-DD HH:mm').toString() : '',
          DatumEnde: this.dateEnd ? moment(this.dateEnd).format('YYYY-MM-DD HH:mm').toString() : '',
          Kategorie: calendarEventItem.id!,
          Wiederholungs: this.periodicity.repeatEveryNthWeek,
          Einmalig: this.periodicity.isUnique,
          EndAfternTimes: this.periodicity.expireAfterRepetitions,
          EndAfterDate: this.periodicity.expireAfterDate ? moment(this.periodicity.expireAfterDate).format('YYYY-MM-DD').toString() : '',
          Montag: this.periodicity.weekDayList.includes(1),
          Dienstag: this.periodicity.weekDayList.includes(2),
          Mittwoch: this.periodicity.weekDayList.includes(3),
          Donnerstag: this.periodicity.weekDayList.includes(4),
          Freitag: this.periodicity.weekDayList.includes(5),
          Samstag: this.periodicity.weekDayList.includes(6),
          Sonntag: this.periodicity.weekDayList.includes(7)
        }

        this.loading = true

        const response: CreateCalendarEventSeriesResponse = await this.$store.dispatch(CREATE_CALENDAR_EVENT, newPeriodicityCalendarEventPayload)
        if(!response.IsError) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true

         const selectedEmployeeList: CalendarEventEmployee[] = []
          response.Series.forEach((item: CalendarEventSerie, index: number) => {
            const foundEmployee: CalendarEventEmployee | undefined = employeeList.find((employee: CalendarEventEmployee) => employee.id ? employee.id === item.Mitarbeiter : false)
            if(foundEmployee) {
              item.Events.forEach((i: KalenderArtVeranstaltungen) => {
                selectedEmployeeList.push(
                    new CalendarEventEmployee(
                      foundEmployee.id,
                      foundEmployee.name,
                      foundEmployee.capacity,
                      foundEmployee.isFloater,
                      foundEmployee.planningGroupName,
                      i.Beschreibung ? i.Beschreibung : '',
                      moment(i.Startzeit!).toDate(),
                      moment(i.Endzeit!).toDate(),
                      index,
                      i.ID
                    )
                )
              })
            }
          })

          let data: PeriodicityPlannedCalendarEventEmployee[] = []
          selectedEmployeeList.forEach((item: CalendarEventEmployee) => {
            let foundItem: PeriodicityPlannedCalendarEventEmployee | undefined

            if (data.length > 0) {
              foundItem = data.find((i: PeriodicityPlannedCalendarEventEmployee) => i.date === moment(item.start).format('DD.MM.YYYY'))
            }

            if (foundItem) {
              foundItem.employeeList.push(item)
            } else {
              data.push({ date: moment(item.start).format('DD.MM.YYYY'), seriesId: response.Series[0].ID ? response.Series[0].ID : null, employeeList: [item] })
            }
          })

          data = _.sortBy(data, [function(o) { return moment(o.date, 'DD.MM.YYYY').format('YYYY-MM-DD'); }])

          this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, data)
          this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_IS_EDITING_SERIE, true)
          this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_SERIE, response.Series)
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch (e) {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.loading = false
        this.onCloseEmployeeSelector()
      }
    }
  }
})
